var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", [
    _c("input", {
      attrs: { type: "hidden", name: `${_vm.prefix}app_label` },
      domProps: { value: _vm.meta.app_label },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "hidden", name: `${_vm.prefix}model_name` },
      domProps: { value: _vm.meta.model_name },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "hidden", name: `${_vm.prefix}selected` },
      domProps: { value: _vm.selected.join(",") },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }